// Определение портала по хосту: та же сборка обслуживает api.verrafied.ai (отчёт + админка)
// и dealer.verrafied.ai / dev.dealer.verrafied.ai (портал дилера).
// Локально портал дилера включается одним из способов:
//   - открыть http://dealer.localhost:3000 (хост начинается с dealer.);
//   - один раз открыть любой URL с ?portal=dealer — выбор запоминается в sessionStorage вкладки,
//     ?portal=default сбрасывает его;
//   - VITE_PORTAL=dealer в .env.local.

const PORTAL_STORAGE_KEY = 'portal'
const DEALER_HOST_PREFIXES = ['dealer.', 'dev.dealer.']

function readForcedPortal(): string | null {
  const fromQuery = new URLSearchParams(window.location.search).get('portal')
  try {
    if (fromQuery === 'dealer') sessionStorage.setItem(PORTAL_STORAGE_KEY, 'dealer')
    else if (fromQuery !== null) sessionStorage.removeItem(PORTAL_STORAGE_KEY)
    return sessionStorage.getItem(PORTAL_STORAGE_KEY)
  } catch {
    // sessionStorage может быть недоступен (приватный режим, запрет cookies) — работаем только по query
    return fromQuery
  }
}

function detectDealerPortal(): boolean {
  const host = window.location.hostname.toLowerCase()
  if (DEALER_HOST_PREFIXES.some((prefix) => host.startsWith(prefix))) return true
  if (import.meta.env.VITE_PORTAL === 'dealer') return true
  return readForcedPortal() === 'dealer'
}

// вычисляется один раз при загрузке: смена портала требует перезагрузки страницы
const IS_DEALER_PORTAL = detectDealerPortal()

export function isDealerPortal(): boolean {
  return IS_DEALER_PORTAL
}
